import * as React from 'react'
import { useCallback } from 'react'
import Button from '@mui/material/Button'

import {
  useSchedulingWizard,
  closeActionCreator as close,
} from './wizardContext'

type CancelButtonProps = {
  _?: never
}

export function CancelButton(_props: CancelButtonProps) {
  const [, dispatch] = useSchedulingWizard()

  const onCancel = useCallback(() => dispatch(close()), [dispatch])

  return (
    <Button variant="text" onClick={onCancel}>
      Cancel
    </Button>
  )
}
